import { Chip, ChipProps } from '@mui/material';

import { useWavelink } from '@/components/providers/WavelinkProvider';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { WavelinkStatus } from '@/hooks/useWavelink';

/**
 * `connected` and `registered` are deliberately distinct: an open SSE stream that never registered
 * still looks healthy for a moment but receives no invalidations and will be dropped by wavelink shortly.
 */
const STATUS_TO_COLOR_MAP: Record<WavelinkStatus, ChipProps['color']> = {
    disconnected: 'error',
    connecting: 'warning',
    connected: 'info',
    registered: 'success',
};

const STATUS_TO_LABEL_MAP: Record<WavelinkStatus, string> = {
    disconnected: 'disconnected',
    connecting: 'connecting',
    connected: 'connected',
    registered: 'live',
};

export const WavelinkStatusChip = () => {
    const mockDataFlag = useFeatureFlag('mockData');
    const wavelinkEnabled = useFeatureFlag('wavelinkEnabled');
    const { status } = useWavelink();

    if (!mockDataFlag) {
        return null;
    }

    // Without the flag the hook never connects, so its `disconnected` would look as a broken connection.
    const label = wavelinkEnabled ? STATUS_TO_LABEL_MAP[status] : 'disabled';
    const color = wavelinkEnabled ? STATUS_TO_COLOR_MAP[status] : 'info';

    return <Chip size="small" variant="outlined" label={`Wavelink ${label}`} color={color} />;
};
